import { IIconBase } from '..'

const moreVerticalIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='-183 0 467 467'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.8734 2.39162C4.78642 12.3046 -8.5916 46.2516 5.8624 73.4716C9.6024 80.5146 20.3634 90.9346 27.4394 94.3646C33.6004 97.3506 44.2784 100.012 50.1014 100.012C55.9244 100.012 66.6024 97.3506 72.7634 94.3646C79.8394 90.9346 90.6004 80.5146 94.3404 73.4716C108.942 45.9736 94.8264 11.1456 65.3964 2.05562C56.1274 -0.807382 42.8424 -0.665383 33.8734 2.39162ZM37.2134 184.628C24.6974 187.994 11.3704 198.658 5.70942 209.838C-4.55158 230.1 -0.603566 253.771 15.5474 268.828C28.6354 281.03 44.2544 285.505 61.3024 281.938C78.1454 278.414 94.0474 262.869 98.5704 245.505C102.955 228.671 98.5164 211.978 86.1364 198.744C73.6994 185.448 54.6254 179.945 37.2134 184.628ZM38.1294 367.649C29.1084 370.073 22.0554 374.18 15.1204 381.047C4.73843 391.328 0.0894119 402.313 0.113412 416.507C0.150412 438.364 14.2574 457.691 34.8064 464.038C43.6024 466.755 56.6004 466.755 65.3964 464.038C85.9454 457.691 100.052 438.364 100.089 416.507C100.113 402.613 95.5144 391.495 85.5764 381.42C72.9574 368.627 54.4644 363.259 38.1294 367.649Z'
        fill={color}
      />
    </svg>
  )
}

export default moreVerticalIcon
